export const periodDictionary = {
  today: 'hoje',
  yesterday: 'ontem',
  lastWeek: 'Últimos 7 dias',
  lastMonth: 'Últimos 30 dias',
} as const;
